export class PatientAdvancedDirective {
  id: number;
  patientId: number;
  type: string;
  typeText: string;
  effectiveFrom: string;
  effectiveTo: string | null;
  documentLocation: string;
}
